import { getUserPhoneNumber } from '../../utils/widget-facade';
import SmsSentInfo from '../common/SmsSentInfo';

interface SmsTextProps {
  container: JQuery<HTMLElement>;
}

export default function SmsText({ container }: SmsTextProps) {
  const phoneNumberWithCountryCode = container.find('.phone-number').text();
  const phoneNumber = getUserPhoneNumber();
  const countryCode = phoneNumberWithCountryCode?.split(phoneNumber)[0];
  return <SmsSentInfo formattedPhoneNumber={countryCode + '-' + phoneNumber} />;
}
